import React from 'react'
import { Button } from '@telavita-core/react-design-kit'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'

import MenuDashboardContainer from './../../containers/MenuDashboardContainer'
import MenuLogout from '../MenuLogout'
import MenuUserInfo from '../MenuUserInfo'
import MenuProfileSwap from '../MenuProfileSwap/'
import Row from '../Row'

import * as routes from './../../settings/_routesSettings'
import * as actions from '../../redux/actions'

import { ReactComponent as TelavitaLogo } from 'static/svg/telavita-logo-grey.svg'
import Close from 'components/CoreIcons/Icons/Close'

const MenuMobile = ({
  isLogged,
  isOpen,
  onClickSwapSelect,
  onCloseClick,
  userProps
}) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleLogout = () => {
    dispatch(actions.authLogout())
  }

  return (
    <>
      <div className={
        clsx({
          'main-menu--container-undefined': isOpen === undefined,
          'main-menu--container': isOpen === true,
          'main-menu--container-closed': isOpen === false
        })
      }>
        <Row className={'main-menu--top-row'}>
          <TelavitaLogo />

          <div className="main-menu--top" onClick={onCloseClick}>
            <Close
              fill='#000'
              height='35px'
              width='35px'
            />
          </div>
        </Row>

        {
          isLogged ? (
            <>
              <div className="main-menu--header">
                <MenuUserInfo {...userProps} />
              </div>
              {
                userProps.profiles.length > 1 ? (
                  <MenuProfileSwap
                    actualProfile={userProps.actualProfile}
                    personProfiles={userProps.profiles ? userProps.profiles : []}
                    onClickSelect={onClickSwapSelect}
                  />
                ) : null
              }
            </>) : null
        }

        <div className={`main-menu ${isLogged ? 'isLogged' : ''}`}>
          <Row className="main-menu--user">
            {
              isLogged ? (
                <>
                  <MenuDashboardContainer userPermissions={userProps.profilePermissions} />
                </>
              ) : (
                <div className='main-menu--buttonswrapper'>
                  <Button 
                    variant='outlined' 
                    customClassName='main-menu--buttonswrapper--signupbutton'
                    onClick={() => history.push(routes.REGISTER)}
                  >
                      Criar conta
                  </Button>
                  <Button 
                    variant='contained' 
                    customClassName='main-menu--buttonswrapper--loginbutton'
                    onClick={() => history.push(routes.LOGIN)}   
                  >
                       Entrar
                  </Button>
                </div>
              )}
          </Row>
          <Row className="main-menu--body"></Row>
          {
            isLogged ? (
              <>
                <Row padding="1rem 0">
                  <div className="main-menu--separator"></div>
                </Row>
                <MenuLogout onHandleLogout={handleLogout} />
              </>
            ) : null
          }
        </div>
      </div>

      {
        isOpen ?
          <div className="black-screen"></div> : null
      }
    </>
  )
}


export default MenuMobile